module.exports = __webpack_public_path__ + "img/perfil.fedb75d9.jpg";